import {
    EDIT_Dl_USER,
    DELETE_DL_USER,
    SET_DL_USER,
    SET_CONTRIBUTOR,
    CHANGE_PRE_MEMBERSHIP,
    ADD_Dl_USER,
    CHANGE_Dl_STATUS,
    DL_PROGRAM_UNENROLL
  } from "../constants";
  
  export const deleteDlUserById = (payload) => ({
    type: DELETE_DL_USER,
    payload: payload,
  });
  
  export const changeDlStatus = (payload) => ({
    type: CHANGE_Dl_STATUS,
    payload: payload,
  });
  
  export const changePreMemberShip = (payload) => ({
    type: CHANGE_PRE_MEMBERSHIP,
    payload: payload,
  });
  
  export const setDlUser = (payload) => ({
    type: SET_DL_USER,
    payload: payload,
  });
  
  export const setContributor = (payload) => ({
    type: SET_CONTRIBUTOR,
    payload: payload,
  });
  
  export const addDlUser = (payload) => ({
    type: ADD_Dl_USER,
    payload: payload,
  });
  
  export const editDlUser = (payload) => ({
    type: EDIT_Dl_USER,
    payload: payload,
  });

  export const DLProgramUnenroll = (payload) => ({
    type: DL_PROGRAM_UNENROLL,
    payload: payload,
  });
  

